export class EMUDATA {

    VQuad_Timestamp: Date;
    Call_Timestamp: Date;
    VQuad_Location: string;
    VQuad_PhoneID: string;

    GPS_Position: string;
    GPS_Lat: number;
    GPS_Long: number;

    StartPoint1: number;
    EndPoint1: number;
    Block1_ERL1: number;
    Block1_Delay1: number;
    Block1_ERL2: number;
    Block1_Delay2: number;
    Block1_ERL3: number;
    Block1_Delay3: number;
    Block1_ERL4: number;
    Block1_Delay4: number;

    StartPoint2: number;
    EndPoint2: number;
    Block2_ERL1: number;
    Block2_Delay1: number;
    Block2_ERL2: number;
    Block2_Delay2: number;
    Block2_ERL3: number;
    Block2_Delay3: number;
    Block2_ERL4: number;
    Block2_Delay4: number;

    StartPoint3: number;
    EndPoint3: number;
    Block3_ERL1: number;
    Block3_Delay1: number;
    Block3_ERL2: number;
    Block3_Delay2: number;
    Block3_ERL3: number;
    Block3_Delay3: number;
    Block3_ERL4: number;
    Block3_Delay4: number;

    StartPoint4: number;
    EndPoint4: number;
    Block4_ERL1: number;
    Block4_Delay1: number;
    Block4_ERL2: number;
    Block4_Delay2: number;
    Block4_ERL3: number;
    Block4_Delay3: number;
    Block4_ERL4: number;
    Block4_Delay4: number;
  
    Call_Control_Event: string;
    CallType_Orig: string;
    CallType_Term: string;
    VQuad_CallID: string;
 
    ID: number;
 
    constructor() {

        this.VQuad_Timestamp = new Date();
        this.Call_Timestamp = new Date();
        this.VQuad_Location = "";
        this.VQuad_PhoneID = "";

        this.GPS_Position = "";
        this.GPS_Lat = 0;
        this.GPS_Long = 0;

        this.StartPoint1 = 0;
        this.EndPoint1 = 0;
        this.Block1_ERL1 = 0;
        this.Block1_Delay1 = 0;
        this.Block1_ERL2 = 0;
        this.Block1_Delay2 = 0;
        this.Block1_ERL3 = 0;
        this.Block1_Delay3 = 0;
        this.Block1_ERL4 = 0;
        this.Block1_Delay4 = 0;

        this.StartPoint2 = 0;
        this.EndPoint2 = 0;
        this.Block2_ERL1 = 0;
        this.Block2_Delay1 = 0;
        this.Block2_ERL2 = 0;
        this.Block2_Delay2 = 0;
        this.Block2_ERL3 = 0;
        this.Block2_Delay3 = 0;
        this.Block2_ERL4 = 0;
        this.Block2_Delay4 = 0;

        this.StartPoint3 = 0;
        this.EndPoint3 = 0;
        this.Block3_ERL1 = 0;
        this.Block3_Delay1 = 0;
        this.Block3_ERL2 = 0;
        this.Block3_Delay2 = 0;
        this.Block3_ERL3 = 0;
        this.Block3_Delay3 = 0;
        this.Block3_ERL4 = 0;
        this.Block3_Delay4 = 0;

        this.StartPoint4 = 0;
        this.EndPoint4 = 0;
        this.Block4_ERL1 = 0;
        this.Block4_Delay1 = 0;
        this.Block4_ERL2 = 0;
        this.Block4_Delay2 = 0;
        this.Block4_ERL3 = 0;
        this.Block4_Delay3 = 0;
        this.Block4_ERL4 = 0;
        this.Block4_Delay4 = 0;

        this.Call_Control_Event = "";
        this.CallType_Orig = "";
        this.CallType_Term = "";
        this.VQuad_CallID = "";
    }
}
